import React, { Component } from 'react'
import { push } from 'react-router-redux';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import 'react-dropdown/style.css'
import $ from 'jquery'

import { newBlankPattern, tryToGetOfficialPatterns } from '../actions/actions.export.js'

import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import RegisterForm from '../components/RegisterForm/RegisterForm.js'
import TextEditor from '../components/TextEditor/TextEditor.js'
import CalculatorEditor from '../components/CalculatorEditor/CalculatorEditor.js'
import Pattern from '../components/Pattern/Pattern.js'
import Pricing from '../components/Pricing/Pricing.js'
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'
import DocThumbnail from '../components/Doc/DocThumbnail.js'


import docLoader from '../docLoader.js'

var pf_config = require('../pf_config.json');

class Home extends Component {
  constructor(props){
    super(props)
  }

  componentWillMount(){
    const { user, dispatch } = this.props;

    // dispatch(tryToGetOfficialPatterns());
  }

  componentDidMount(){
    window.document.title = "Pattycake - .pat file editing made easy";
  }


  render(){
    const { patternManager, dispatch, user, globalReducer } = this.props;
    
    var mies_patterns = [];
    for(let i in patternManager.officialLibrary){
      let p = patternManager.pristineCache[patternManager.officialLibrary[i]];
      if(p.projects.indexOf('Mies Detail') > -1){
        mies_patterns.push(patternManager.officialLibrary[i]);
      }
    }

    mies_patterns.sort((a,b)=>{
      return Math.random() > .5 ? -1 : 1;
    })

    let row_patterns = [];

    if(patternManager.officialLibrary.length > 1 && patternManager.officialCalculators.length > 1){
      while(row_patterns.length < 8){
        let i = parseInt(Math.random() * patternManager.officialLibrary.length);
        let p = patternManager.pristineCache[patternManager.officialLibrary[i]];
        if(p.projects.indexOf('Pro Only') === -1){
          row_patterns.push(p.id);
        }
      }
    }

    return <div className="landing">
      
      <Header/>
      <div className="section-breaker section-breaker-white">
        <div className="container">
          <div className="row row-padded">
            <div className="col-md-4 landing-pad-fix">
              <h1>The world's best hatch pattern editor.</h1>
              <p className="lead soft">
                Pattycake is a browser-based .PAT file editing and creation tool for architects and designers.
              </p>
              <p className="lead soft">
                Included is the largest library of free hatch patterns for personal & commercial use.
              </p>
              <br/>
              <Link to="/new/drawing" className="button-link d-none d-md-block" onClick={(e)=>{ dispatch(newBlankPattern()) }}>
                {
                  user.isLoggedIn ?
                  <Button display={<span>Launch Pattycake{user.roles.pro ? " Pro" : ""} &nbsp;<i className="fad fa-angle-double-right"/></span>} size="large" color="primary"/>
                  :
                  <Button display={<span>Try Pattycake &nbsp;<i className="fad fa-angle-double-right"/></span>} size="large" color="primary"/>
                }
              </Link>
            </div>
            <div className="col-md-8">
              <video className="video-screenshot" width="100%" autoPlay muted loop noControls>
                <source src="/vid/v2.mp4" type="video/mp4"/>
                <source src="/vid/v2.ogv" type="video/ogg"/>
                <source src="/vid/v2.webm" type="video/webm"/>
              Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>


      <div className="section-breaker section-breaker-white">
        <div className="container">
          <div className="row row-padded" id="what">
            <div className="col-md-12">
              <div className="section-label">
                What is a .PAT file?
              </div>
            </div>
            <div className="col-md-6">
              <h2>A few small but mighty lines of text.</h2>
              <p className="lead soft">
                Each hatch pattern is stored in a .PAT file as a collection of rules describing the angle and spacing of infinitely repeating lines in order to represent a particular material or meaning.
              </p>
            </div>
            
          </div>
          <div className="row row-push-down-extra">
            <div className="col-md-6">
              <p className="soft">a .PAT file that looks like this...</p>
              <div className="col-themed col-themed-no-pad theme-dark" style={{height: 250}}>
                <TextEditor demo={true} cacheID={'features_text'}/>
                <div className="banner banner-yellow">Edit me!</div>
              </div>
            </div>

            <div className="col-md-6">
              <p className="soft">...tells your architecture software to display this:</p>
              <div className="col-themed col-themed-no-pad" style={{height: 250}}>
                <Pattern colors={false} gui={false} pattern={patternManager.cache['features_text']}/>
              </div>
            </div>
            <div className="col-md-12">
              <h5 className="row-push-up">Want to learn more?</h5>
            </div>
            <div className="col-md-4">
              <p className="soft">This interactive tutorial will make you a pro:</p>
              <DocThumbnail doc={docLoader.dictionary['pat-from-scratch-intro-tutorial']}/>
            </div>
            <div className="col-md-4">
              <p className="soft">Check out some of the benefits of .PAT files</p>
              <DocThumbnail doc={docLoader.dictionary['five-benefits-of-pat-files']}/>
            </div>
            <div className="col-md-4">
              <p className="soft">Learn more about .PAT file format:</p>
              <DocThumbnail doc={docLoader.dictionary['pat-file-syntax-and-rules']}/>
            </div>
          </div>
        </div>
      </div>


      <div className="section-breaker">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <blockquote>
                <p>Pattycake has made a serious difference in understanding pattern files.</p>
                <footer>— Autodesk Forums User</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>



      <div className="section-breaker section-breaker-white">
        <div className="container">
          <div className="row row-padded" id="what">
            <div className="col-md-12">
              <div className="section-label">
                How does Pattycake help?
              </div>
            </div>
            <div className="col-md-6">
              <h2>Three innovative tools in one.</h2>
              <p className="lead soft">
              
              </p>
            </div>
          </div>

          <div className="row row-push-down-extra">

            <div className="col-md-4">
              <img src="/img/calculator.png" className="flat-icon-p" width="128px" height="128px"/>
              <div className="lead soft">
                Need to tweak a common pattern?  
              </div>
              <p className="text-700">
                Pattycake has templates that make it easy.
              </p>
            </div>

            <div className="col-md-4">
              <img src="/img/pencil.png" className="flat-icon-p" width="128px" height="128px"/>
              <div className="lead soft">
                Have a complex design?
              </div>
              <p className="text-700">
                With Pattycake, you can simply draw it.
              </p>
            </div>

             <div className="col-md-4">
              <img src="/img/clock.png" className="flat-icon-p" width="128px" height="128px"/>
              <div className="lead soft">
                Do you speak fluent .PAT?
              </div>
              <p className="text-700">
                Pattycake can visualize changes in real time. 
              </p>
            </div>
          </div>

          <div className="row row-padded">
            <div className="col-md-6">
              <p className="soft">With Pattycake templates, you can edit a few fields:</p>
              <div className="col-themed col-themed-dark col-themed-no-pad theme-dark" style={{height: 250}}>
                <CalculatorEditor cacheID={'features_text2'} demo={true}/>
                <div className="banner banner-yellow">Edit me!</div>
              </div>
            </div>

            <div className="col-md-6">
              <p className="soft">...and instantly get the .PAT file you need:</p>
              {/*<div className="col-themed col-themed-no-pad theme-light" style={{height: 250}}>
                <TextEditor demo={true} cacheID={'features_text'}/>
              </div>*/}
              <div className="col-themed col-themed-no-pad" style={{height: 250}}>
                <Pattern colors={false} gui={false} pattern={patternManager.cache['features_text2']}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-breaker">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 text-center">
              <blockquote>
                <p>Used at over <nobr>500 firms </nobr> in more than <nobr>25 countries</nobr> <nobr>on every continent.</nobr></p>
                <footer>(minus Antartica, for now)</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>



      <div className="section-breaker section-breaker-white">
        <div className="container">
          <div className="row row-padded" id="why">
            <div className="col-md-12">
              <div className="section-label">
                Why do patterns matter?
              </div>
            </div>
            <div className="col-md-6">
              <h2>Better patterns <nobr>make better drawings.</nobr> </h2>
              <p className="lead soft">
                When it's easier to create the perfect pattern, your drawings can tell a more accurate and descriptive story. 
              </p>
              <div className="container-fluid-nested">
                <div className="row theme-light">
                  <div className="col-md-12">
                    <p>
                      <small>
                        Check out a few of the <strong>{mies_patterns.length} patterns</strong> used in this single detail drawing:
                      </small>
                    </p>
                  </div>
                  {
                    mies_patterns.map((p, i)=>{
                      if(i >= 9) return;
                      return <div className="col-md-4" key={i}>  
                        <PatternThumbnail 
                          cacheID={p} 
                          light={true} 
                          simple={true} 
                          official={true}
                          />
                      </div>
                    })
                  }
                </div>
              </div>
            </div>
        
            <div className="col-md-6">
              <img src="/img/mies_detail.jpg" width="100%"/>
            </div>
          </div>
        </div>
      </div>



      <div className="section-breaker">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <blockquote>
                <p>This resolved my issue, but on a much more important note, Pattycake is beautiful! <br/>Where has this been all of my life? 😭</p>
                <footer>— Josh H.</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>


      <div className="section-breaker section-breaker-white">
        <div className="container">
          <div className="row row-padded" id="features">
            <div className="col-md-12">
              <div className="section-label">
                What makes Pattycake unique?
              </div>
            </div>
            <div className="col-md-7">
              <h2>Architecture software is stuck in the past.</h2>
              <p className="lead soft">
                Pattycake helps you create the pattern you need, <nobr>the moment you need it, without any of the headaches.</nobr>
              </p>
            </div>
          </div>
          <div className="row row-no-gutter row-padded">

            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*<span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-browser fa-stack-1x fa-inverse"></i>
                </span>*/}
                <img src="/img/wifi-router.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>No complicated installs</h3>
                <p className="lead no-margin-bottom">
                  100% web-based, accessible from anywhere - even your phone. 
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*<span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-computer-classic fa-stack-1x fa-inverse"></i>
                </span>*/}
                <img src="/img/open.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>Always compatible</h3>
                <p className="lead no-margin-bottom">
                  Whether you're using Revit 2020 or AutoCAD 2010 - Pattycake just works.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*<span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-box-full fa-stack-1x fa-inverse"></i>
                </span>*/}
                <img src="/img/toolbox.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>Three tools in one</h3>
                <p className="lead no-margin-bottom">
                  Powerful text editor, integrated drawing, and algorithmic templates.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*<span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-hand-holding-usd fa-stack-1x fa-inverse"></i>
                </span>*/}
                <img src="/img/calendar.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>No commitments</h3>
                <p className="lead no-margin-bottom">
                  Pay monthly, cancel anytime. No licenses or versions to navigate.
                </p>
              </div>
            </div>


            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*
                <span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-books fa-stack-1x fa-inverse"></i>
                </span>*/}
                <img src="/img/loupe.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>Free library of patterns</h3>
                <p className="lead no-margin-bottom">
                  Always growing library of more than 400 materials in every format.
                </p>
              </div>
            </div>


            <div className="col-md-4">
              <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
                {/*
                <span className="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-comment-alt-smile fa-stack-1x fa-inverse"></i>
                </span>
                */}
                <img src="/img/positive-vote.png" className="flat-icon-p" width="128px" height="128px"/>
                <h3>Helpful feedback</h3>
                <p className="lead no-margin-bottom">
                  Built-in error detection for confusing and specific .PAT limitations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="section-breaker">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 text-center">
              <blockquote>
                <p>I was definitely not expecting how amazing this website is.</p>
                <footer>— Alex F.</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>



      <div className="section-breaker">
        <div className="container">
          <div className="row row-padded" id="pricing">
            <div className="col-md-12">
              <div className="section-label">
                How much does it cost?
              </div>
            </div>
            <div className="col-md-6">
              <h2>Pattycake can grow with you.</h2>
              <p className="lead soft">
                Whether just you're starting out or at a global firm, we've got a plan for you. No budget at all? We will <strong>always</strong> have a free version.
              </p>
            </div>
          </div>
        </div>
        <Pricing/>
      </div>

      
      <div className="section-breaker">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 text-center">
              <blockquote>
                <p>I needed a new pattern for a resinous flooring hatch, and luckily you had <nobr>what I needed!</nobr></p>
                <footer>— Bailey T.</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>


      <div className="section-breaker">
        <div className="container">
          <div className="row row-padded">
            <div className="col-md-12">
              <div className="section-label">
                What's in the library?
              </div>
            </div>
            <div className="col-md-6">
              <h2>But wait, there's more.</h2>
              <p className="lead soft">
                Here's a sampling of the 400+ free patterns available when you sign up for a free Pattycake account.
              </p>
              <Button
                display={<span> <i className="far fa-sync fa-small"/>&nbsp;&nbsp;&nbsp;Show me more</span>}
                onClick={()=>{ this.setState({
                    refresh: new Date().getTime()
                  })
                }}
              />
            </div>
          </div>
          <div className="row row-padded">
            {
              row_patterns.map((p, i)=>{
                return <div className="col-md-3 theme-light" key={i}>
                  <PatternThumbnail 
                    cacheID={p} 
                    light={true}
                    simple={true}
                    registerBeforeNavigating={true}
                    registerBeforeNavigatingIntro={"You're almost there"}
                    registerBeforeNavigatingTagline={"This hatch pattern is all yours when you sign up for a free account."}
                    />
                </div>
              })
            }
          </div>
        </div>
      </div>

      
      {
        !user.isLoggedIn &&
        <div className="section-breaker section-breaker-white">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5">
                <h3 className="text-400 text-center">Ready to Dive In?</h3>
                <p className="lead text-center">
                  We're glad you're here.
                </p> 
                <br/>
                <RegisterForm/>
              </div>
            </div>
          </div>
        </div>
      }

      <Footer/>
    </div>

  }
}



const mapStateToProps = (state) => {
  const { 
    user,
    patternManager,
    globalReducer
  } = state;

  return {
    user,
    patternManager,
    globalReducer
  }
}

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/routes/LandingPage.js